/**
 * =============================================================================
 *  API 的來源（origin）—— 網站與 iOS App 的唯一差別點。
 *
 *  · 網站：`VITE_API_ORIGIN` 不設 → 空字串 → 一律相對路徑（dev 走 vite proxy、
 *    正式走 Caddy 同源），工作階段是 HttpOnly cookie，`credentials: 'same-origin'`。
 *  · iOS App（Capacitor，option B）：頁面來源是 `capacitor://localhost`，建置時設
 *    `VITE_API_ORIGIN=https://<mac>.<tailnet>.ts.net` → 每一個請求都是跨來源的絕對網址，
 *    認證走 `Authorization: Bearer`（lib/auth/token-store.ts），**不帶 cookie**
 *    （`credentials: 'omit'`；後端 CORS 也是 `allow_credentials=False`）。
 *
 *  所有打 API 的網址都從這裡組：openapi client 的 baseUrl、SSE 串流、`<a href>` 下載。
 * ========================================================================== */

function normaliseOrigin(raw: unknown): string {
  if (typeof raw !== 'string') return '';
  // 結尾斜線拿掉：路徑一律以 `/api/...` 開頭，`https://x/` + `/api` 會變成 `//api`。
  return raw.trim().replace(/\/+$/, '');
}

/** 建置期決定，執行期不變。空字串＝同源。 */
export const API_ORIGIN: string = normaliseOrigin(import.meta.env['VITE_API_ORIGIN']);

/** 跨來源（App）不帶 cookie；同源（網站）照舊帶。 */
export const API_CREDENTIALS: RequestCredentials = API_ORIGIN === '' ? 'same-origin' : 'omit';

/** `/api/v1/...` → 網站原樣（相對路徑）；App 前面接上 API_ORIGIN。 */
export function apiUrl(path: string): string {
  return `${API_ORIGIN}${path}`;
}
